import { render } from "./HiCard.vue?vue&type=template&id=0215af27&scoped=true"
import script from "./HiCard.vue?vue&type=script&lang=js"
export * from "./HiCard.vue?vue&type=script&lang=js"

import "./HiCard.vue?vue&type=style&index=0&id=0215af27&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0215af27"]])

export default __exports__